import { EpRoleDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/ep-roles`;

export const getAllEpRoles = (source: CancelTokenSource): Promise<Array<EpRoleDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchEpRole = (query: String, source: CancelTokenSource): Promise<Array<EpRoleDto>> => {
  return axios
      .get(`${apiUri}`, {params: {query}, cancelToken: source.token})
      .then(response => response.data);
};

export const findEpRoleById = (roleId: string, source: CancelTokenSource): Promise<EpRoleDto> => {
  return axios
      .get(`${apiUri}`, {params: {roleId}, cancelToken: source.token})
      .then(response => response.data)
};

export const addEpRole = (epRoleDto: Partial<EpRoleDto>, source: CancelTokenSource): Promise<EpRoleDto> => {
  return axios
      .post(apiUri, epRoleDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editEpRole = (roleId: string, epRoleDto: Partial<EpRoleDto>,
                           source: CancelTokenSource): Promise<EpRoleDto> => {
  return axios
      .put(`${apiUri}`, epRoleDto, {params: {roleId}, cancelToken: source.token})
      .then(response => response.data);
};

export const deleteEpRole = (roleId: string, source: CancelTokenSource): Promise<String> => {
  return axios
      .delete(`${apiUri}`, {params: {roleId}, cancelToken: source.token})
      .then(response => response.data);
};


